import React, { useEffect, useState } from "react"
import { getScreeners } from "@src/redux/api/project/screeners"
import PropTypes from "prop-types"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { Status, Table } from "@bitcine/cs-theme"
import dayjs from "dayjs"
import { push } from "connected-react-router"
import { SourceFile } from "../../files/icon/icons"
import DropdownOptions from "../screener/dropdown_options"

const Screeners = ({ getScreeners, screeners, status, push }) => {
  const defaultSorting = JSON.parse(localStorage.getItem("screener_sorting")) || { key: "created_at", direction: "desc" }
  const [sorting, setSorting] = useState(defaultSorting)
  const [search, setSearch] = useState()
  useEffect(() => {
    getScreeners(search, sorting)
  }, [search, sorting])
  return (
    <Status pending={status === "PENDING"} error={status === "ERROR"}>
      <div className='p2'>
        <div className='flex items-center justify-between'>
          <h4>Screeners</h4>
          <div className='flex'>
            <input
              className='cs-input'
              value={search}
              style={{ height: "34px" }}
              onChange={e => setSearch(e.target.value)}
              placeholder='Search for a screener...'/>
          </div>
        </div>
        <Table
          className='my3'
          widths={[65, "auto", 600, 140, 140, 65]}
          header={{
            columns: [{ text: "" }, { text: "Screener Name", key: "name" }, { text: "Source File Name" }, { text: "Status" }, { text: "Created", key: "created_at" }, { text: "" }],
            sorting: {
              direction: sorting.direction,
              key: sorting.key,
              onSortChange: sorting => {
                setSorting(sorting)
                localStorage.setItem("screener_sorting", JSON.stringify(sorting))
              }
            }
          }}
          body={{
            data: screeners,
            row: {
              onClick: (event, data) => push(`/projects/${data.project_id}/files/preview-link/${data._id}`),
              render: [
                data => <SourceFile screener={data}/>,
                data => <div className='w-full inline-block break-word'>{data.name}</div>,
                data => <div className='w-full inline-block break-word'>{data.source_file?.name}</div>,
                data => (
                  <div className={`flex-auto capitalize ${data.status && data.status.toLowerCase() === "ready" ? "green" : "red"}`}>
                    {data.status || 'Not ready'}
                  </div>
                ),
                data => dayjs(data.created_at).format("MMM Do, YYYY"),
                data => <DropdownOptions screener={data} onThumbnailUploaded={() => getScreeners(search, sorting)}/>
              ]
            }
          }}/>
      </div>
    </Status>
  )
}

Screeners.propTypes = {
  getScreeners: PropTypes.func.isRequired,
  screeners: PropTypes.array.isRequired,
  status: PropTypes.string.isRequired,
  push: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  screeners: state.project.screeners.items,
  status: state.project.screeners.status
})

const mapDispatchToProps = dispatch => ({
  getScreeners: bindActionCreators(getScreeners, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Screeners)